module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1022-3b5af63942d7224c1655efb27619b5c5.png";